import { FC } from 'react';

import { cn } from '@distribute/frontend/utils';
import { Avatar } from '../../../shared/ui';

type Props = {
  displayName: string;
  photoUrl?: string;
  className?: string;
};

export const CreatedBy: FC<Props> = ({ displayName, photoUrl, className }) => {
  return (
    <div
      className={cn(
        'flex flex-nowrap items-center gap-x-2 truncate',
        className
      )}
    >
      <Avatar
        displayName={displayName}
        src={photoUrl}
        size="xs"
        isUserAvatar
        className="border border-base-black/[0.08]"
      />
      <div className="text-sm text-gray-700 truncate">
        Created by{' '}
        <span className="font-semibold text-gray-900">{displayName}</span>
      </div>
    </div>
  );
};
